document.addEventListener('turbolinks:load', function () {
    if ($('.organizations.show, .client_updates.show').length === 0) {
        return false
    }

    if ($('.organizations.show').length > 0) {
        var myModal = document.querySelectorAll('.clientUpdateDetailModal')
        myModal.forEach(function (modal) {
            modal.addEventListener('shown.bs.modal', function () {
                var form = $(this).find('form')
                submitOnEnter(form)
            })
        })
    }

    if ($('.client_updates.show').length > 0) {
        var form = $('.client-update-comment-form')
        submitOnEnter(form)
    }

    function submitOnEnter(form) {
        $(form).on('keypress', function (e) {
            // Check if Enter key is pressed
            if (e.keyCode === 13 && !e.shiftKey) {
                $(form).find('.comment-btn').click()
            }
        });
    }
});